<div>
    <label class="uploader" ondragover="return false;"
        [class.loaded]="loaded" 
        [style.outlineColor]="dragging ? activeColor : baseColor"
        (dragenter)="handleDragEnter()"
        (dragleave)="handleDragLeave()"
        (drop)="handleDrop($event)">
        
        <i class="icon icon-upload" 
            [style.color]="dragging 
                ? ((imageSrc.length > 0) ? overlayColor : activeColor)
                : ((imageSrc.length > 0) ? overlayColor : baseColor)"></i>
        
        <img
            [src]="imageSrc" 
            (load)="handleImageLoad()" 
            [class.loaded]="imageLoaded"/>
        
    
    </label>
    <input #fileInput id="input-file" type="file" name="file" accept="image/*" (change)="handleInputChange($event)" style="display: none">

    <div class="row">
        <button class="col" nbButton size="small" style="margin: 5px;" status="success" (click)="fileInput.click(); $event.preventDefault();" translate>load_file</button>
        <button class="col" nbButton size="small" style="margin: 5px;" status="danger" (click)="cancel(); $event.preventDefault();" translate>clear_image</button>
        <button *ngIf="showGalleryButton" class="col" nbButton size="small" style="margin: 5px;" status="info" (click)="openDefaultImagesWindow($event);" translate>open_default_images_window</button>
    </div>

</div>